import React from 'react';
import { Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import RegisteredCancellations from '../RegisteredCancellations';
import CancelConsumptionPoint from '../FormGroups/CancelConsumptionPoint';
import UserFullName from '../FormGroups/UserFullName';
import LocationFact from '../FormGroups/LocationFacts';
import { Jumbotron } from 'reactstrap';
import '../../styles/loading.css';


const initialState = {
  contractId: '',
  meternumber: '',
  meterreading: '',
  metertype: '',
  accountnumber: '',
  deliveryEndDate: '',
  street: '',
  housenumber: '',
  housenumberextension: '',
  postcode: '',
  additionalMeter: 'gas',
  additionalMeternumber: '',
  additionalMeterreading: '',
  additionalContractNumber: '',
  city: '',
  addedGas: false,
  nextTenantKnown: false,
  NextTenant: {
    salutation: '02'
  },
  loading: false,
  failed: false,
  notValid: false
}

const initialValidation = {
  adressValidation: false,
  locationValidation: false,
  nextTenantVal: true
}

class CancelLocationStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };

    this.submitted = false;
    this.duplicate = false;
    this.validForm = {
      ...initialValidation
    };
    this.validationLoading = false;
    this.validationFailed = false;
    this.errorMessage = "";

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNextTenant = this.handleNextTenant.bind(this);
    this.isValidated = this.isValidated.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.isNextTenantValid = this.isNextTenantValid.bind(this);
    this.handleChangeChecked = this.handleChangeChecked.bind(this);
  }

 
  componentDidMount(){
    this.setState({
      metertype: this.props.type
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleNextTenantChange(nextTenantKnown){
    this.setState({
      nextTenantKnown: nextTenantKnown
    });
    this.validForm.nextTenantVal = !nextTenantKnown;
  }

  handleLocationRemoval(event){
    const reg = this.props.LocationCancellations.filter(reg => reg.meternumber === event.currentTarget.id)[0]

    const indexOfElement = this.props.LocationCancellations.indexOf(reg);
    this.props.removeCancellation(indexOfElement);
  }

  handleNextTenant(event) {
    const locations = {...this.state};

    locations.NextTenant[event.target.name] = event.target.value;
    this.setState(locations);
  }

  async handleSubmit(event){
    event.preventDefault();
    this.duplicate = false;
    this.submitted = true;
    this.forceUpdate(); 
    if(this.validForm.locationValidation && this.validForm.adressValidation && this.validForm.nextTenantVal){
      const cancellations = this.props.LocationCancellations;
      if (cancellations.length > 0) {
        if(this.state.accountnumber === cancellations[0].accountnumber || this.state.meternumber === cancellations[0].meternumber) {
          this.duplicate = true;
          return;
        }
      }
      const newLocation = this.state;
      const cancellation = this.props.LocationCancellations;
      console.log(cancellation);
      document.getElementById("addLocationButton").classList.remove("input-needed");
      this.setState({
        loading: true
      }, () => {
        console.log("loading")
        });
  
      this.validateCancellation(newLocation, async (response) => {
        if (response.status === 200) {
          var result = await response.json();
          
          this.setState({
            contractId: result.contractId,
            notValid: false,
            failed: false,
            loading: false
          }, () => {
            console.log("success")
            });


          
        this.props.addCancellation(this.state);
        await this.addGas();
        this.setState({...initialState,  NextTenant: {...initialState.NextTenant}, metertype: this.props.type}, () => {
          this.validForm = {
            ...initialValidation
          }
          this.submitted= false;
          this.resetCheckbox();
          this.forceUpdate(); 
        });
        }
        if(response.status === 500) {
            this.setState({
              failed: true,
              loading: false
            }, () => {
              console.log("failed")
              });
          }
        if (response.status === 400) {
          response.text().then((result) => {
            console.log(result);
            this.errorMessage = result;
            this.setState({
              notValid: true,
              loading: false
            }, () => {
              console.log("invalid")
            });
          });     
        }
      });
    }
  }
  resetCheckbox() {
    this.setState({
      addedGas: false});
  }
  handleChangeChecked() {
    this.setState({
      addedGas: !this.state.addedGas});
  }

validateCancellation(location, callback) {
  var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const request = new Request(
      "api/location/validate",
      {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(location)
      });
    fetch(request).then(function(response) {
      callback(response);
      return response;
    })
    return request;
}

 async addGas() {
    if (this.state.addedGas && this.state.metertype === "electricity") {
      this.setState({
        metertype: this.state.additionalMeter,
        meternumber: this.state.additionalMeternumber,
        meterreading:   this.state.additionalMeterreading,
        accountnumber: this.state.additionalContractNumber
      }, () => {
      var newLoc = this.state;
      this.props.handleAdditionalGas();
      this.props.addCancellation(newLoc)
    });
  }
 }

  isValidated() {
    if(this.props.LocationCancellations.length !== 0) {
      return true;
    }
    document.getElementById("addLocationButton").classList.add("input-needed");
    return false;
  }

  isFormValid(isValid, whereValid) {
    this.validForm[whereValid] = isValid;
  }

  isNextTenantValid(isValid, whereValid) {
    this.isFormValid(isValid, 'nextTenantVal');
  }

  render() {
    let duplicateError;
    if (this.duplicate) {
      duplicateError =
        <h5 style={{ color: 'red', marginTop: '5px' }}>Verbrauchsstelle bereits hinzugefügt! Bitte überprüfen Sie ihre Angaben und fügen die Verbrauchstelle erneut hinzu.</h5>
    }
    var headline= '';
    if (this.state.metertype === 'gas' ) {
      headline= 'Bitte melden Sie Ihre ERDGAS-Verbrauchsstelle mittels der Vertragskontonummer bei der GASAG ab.';
    }
    else {
      headline= 'Bitte melden Sie Ihre STROM-Verbrauchsstelle mittels der Vertragskontonummer bei der GASAG ab.'
    }
    let loader;
    let error = this.errorMessage;
    if(this.state.loading){
      loader = 
          <Jumbotron>
              <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
              <h1 className="display-3">Einen Augenblick Geduld</h1>
              <p className="lead">Ihre Daten werden überprüft</p>
              <p>Einen Moment bitte.</p>
          </Jumbotron>
    }
    if(this.state.notValid && this.state.loading === false) {
      loader = 
      <Jumbotron>
        <p className="lead" style={{ color: 'red' }}>{error}</p>
        <hr className="my-2" />
        <p className="lead">Bitte überprüfen Sie diese Angaben und fügen Sie die Verbrauchsstelle erneut hinzu.</p>
      </Jumbotron>
    }
    if(this.state.failed && this.state.loading === false) {
        loader = 
        <Jumbotron>
              <h1 className="display-3">Etwas ging leider schief!</h1>
              <p className="lead">Bitte versuchen Sie es nochmal in wenigen Minuten.</p>
              <hr className="my-2" />
        </Jumbotron>
    }
    let nextTenantField
    if (this.state.addedGas || this.state.metertype === "gas") {
       nextTenantField =
        <Row>
          <FormGroup tag="fieldset">
          <legend>Angaben zum Nachmieter</legend>
          <FormGroup check>
            <Label check>
            <Input type="radio" defaultChecked={this.state.nextTenantKnown} name="next-tenant-known" onClick={this.handleNextTenantChange.bind(this, true)}/>{' '}
              Der Nachmieter ist bekannt.
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input type="radio" defaultChecked={!this.state.nextTenantKnown} name="next-tenant-known" onClick={this.handleNextTenantChange.bind(this, false)}/>{' '}
              Der Nachmieter ist unbekannt.
              </Label>
          </FormGroup>
        </FormGroup>
      </Row>
    };
    return(
    <div>
    <Form onSubmit={this.handleSubmit}>

        <hr></hr>
        <h5>{headline}</h5>
        <hr></hr>
        <LocationFact changeHandler={this.handleChange}
                    submitted={this.submitted}
                    state={this.state}
                    isValidForm={this.isFormValid}
                    isRegistration={false} />
        
        <CancelConsumptionPoint changeHandler={this.handleChange}
                    submitted={this.submitted}
                    state={this.state}
                    isValidForm={this.isFormValid}
                    isRegistration={false}
                    type={this.props.type}
                    handleChangeChecked={this.handleChangeChecked}
                    checked={this.state.addedGas}
                    additionalMeternumber= {this.state.additionalMeternumber}
                    additionalMeterreading= {this.state.additionalMeterreading} />
        
        {nextTenantField}

        { this.state.nextTenantKnown ? <UserFullName changeHandler={this.handleNextTenant}
                                                    submitted={this.submitted}
                                                    state={this.state.NextTenant}
                                                    isValidForm={this.isNextTenantValid} /> : null }

        <hr></hr>
        <h5>Bitte klicken Sie auf "Verbrauchsstelle hinzufügen", um Ihre Angaben zu bestätigen. Um weitere Verbrauchstellen abzumelden, füllen Sie bitte die obigen Eingabefelder erneut aus und klicken wieder auf "Verbrauchsstelle hinzufügen".</h5>
        <hr></hr>
        <Button className="mt-1" id="addLocationButton" type="submit" value="Submit">Verbrauchstelle hinzufügen</Button>
        {duplicateError}
      </Form>
      {loader}
      <RegisteredCancellations LocationCancellations={this.props.LocationCancellations} HandleCancellationRemoval={this.handleLocationRemoval.bind(this)} />
      </div>
    );
  }
}

export default CancelLocationStep;


// WEBPACK FOOTER //
// ./src/components/Steps/CancelLocationStep.js